import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import StripeForm from "../../components/Stripe/StripeForm";
import { AddPaymentMethodAction } from "../../redux/actions/paymentmethods";

const AddPayment = ({ auth, addCard }) => {
    const navigate = useNavigate();
    const stripeTokenHandler = (token) => {
        addCard(token).then(() => {
            navigate("/view-card");
        });
    };
    return (
        <>
            <Header />
            <section className="jobs">
                <div className="container">
                    <div className="row"></div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <fieldset className="border p-3 ">
                                <legend className="w-auto blue">
                                    Add Payment
                                </legend>
                                <StripeForm
                                    stripeTokenHandler={stripeTokenHandler}
                                />
                                {/* <div className="row py-2">
                                        <div className="col-md-12 col-sm-12">
                                            <label
                                                className="altlable"
                                                for="name"
                                            >
                                                Card Title
                                            </label>
                                            <input
                                                className="altinput"
                                                type="text"
                                                id="name"
                                                placeholder="Enter Card Title"
                                            />
                                        </div>
                                        <div className="col-md-12 col-sm-12 pt-3">
                                            <label
                                                className="altlable"
                                                for="name"
                                            >
                                                Card Number
                                            </label>
                                            <input
                                                className="altinput"
                                                type="text"
                                                id="name"
                                                placeholder="Enter Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="row py-2">
                                        <div className="col-md-6 col-sm-12">
                                            <label
                                                className="altlable "
                                                for="name"
                                            >
                                                CVV
                                            </label>
                                            <input
                                                className="altinput cardno"
                                                type="text"
                                                id="name"
                                                placeholder="Enter CVV"
                                            />
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <label
                                                className="altlable "
                                                for="name"
                                            >
                                                Expire Date
                                            </label>
                                            <input
                                                className="altinput cardno"
                                                type="text"
                                                id="name"
                                                placeholder="Enter Expire Date"
                                            />
                                        </div>
                                    </div> */}
                            </fieldset>
                            {/* <div className="row py-4">
                                    <div className="col-md-6 col-sm-12 text-right">
                                        <a
                                            className="btn btn-secondary"
                                            href="thank-you.php"
                                        >
                                            Save
                                        </a>
                                    </div>
                                </div> */}
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    addCard: async (stripeToken) => dispatch(await AddPaymentMethodAction(stripeToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPayment);
